import settingsActionCreatorFactory from 'typescript-fsa'
import { Theme } from '@mui/material'
import { UserSettings } from '@professocialApi/professocial-core-frontend-api'

import { Message } from '@professocial/professocialTypes/types/messageTypes'

export const settingsActionCreator = settingsActionCreatorFactory('SETTINGS')
/**
 * Actions
 */

// settings actions
export const setConfiguration = settingsActionCreator<never>('SET_CONFIGURATION')
export const setTheme = settingsActionCreator<Theme>('SET_THEME')
export const setMessage = settingsActionCreator<Message>('SET_MESSAGE')
export const setUser = settingsActionCreator<UserSettings | undefined>('SET_USER')

export const getCurrentUserInitiated = settingsActionCreator('GET_CURRENT_USER_INITIATED')
export const getCurrentUser = settingsActionCreator.async<undefined, UserSettings>('GET_CURRENT_USER')
